import React from 'react';
import Three from "../assets/installation/three.png";
import Four from "../assets/installation/four.png";
import Five from "../assets/installation/five.png";
import Six from "../assets/installation/six.png";
import Seven from "../assets/installation/seven.png";
import Eight from "../assets/installation/eight.png";
import Nine from "../assets/installation/nine.png";
import { useTranslation } from "../useTranslation";

const AndroidGuide = () => {
  const { t } = useTranslation();

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          {t('installation.title')}
        </h1>
        <div className="text-sm text-gray-500 mb-6">
          {t('installation.metaUpdated')}
        </div>
        <div className="h-px bg-gray-200 mb-8"></div>
      </div>

      {/* Introduction */}
      <div className="mb-8">
        <p className="text-gray-700 mb-4">
          {t('installation.intro.p1')}
        </p>

        <p className="text-gray-700 mb-4">{t('installation.intro.p2')}</p>

        <ol className="list-decimal list-inside mb-4 space-y-2 text-gray-700">
          <li>{t('installation.intro.ol1')}</li>
          <li>{t('installation.intro.ol2')}</li>
        </ol>

        <p className="text-gray-700 mb-8">{t('installation.intro.note')}</p>
      </div>

      {/* Android QR Installation */}
      <section className="mb-12">
        <h2 className="text-2xl font-bold text-gray-900 mb-6">
          {t('installation.android.qr.title')}
        </h2>

        <div className="space-y-8">
          <div>
            <h3 className="text-lg font-medium text-gray-900 mb-4">
              {t('installation.android.qr.s1')}
            </h3>
            <img
              src={Three}
              alt="Android Settings - Network & Internet - SIMs"
              className="max-w-lg mx-auto border border-gray-200 rounded-lg shadow-sm"
            />
          </div>

          <div>
            <h3 className="text-lg font-medium text-gray-900 mb-4">
              {t('installation.android.qr.s2')}
            </h3>
          </div>

          <div>
            <h3 className="text-lg font-medium text-gray-900 mb-4">
              {t('installation.android.qr.s3')}
            </h3>
            <img
              src={Four}
              alt="Android Download a SIM instead"
              className="max-w-xs mx-auto border border-gray-200 rounded-lg shadow-sm"
            />
          </div>

          <div>
            <h3 className="text-lg font-medium text-gray-900 mb-4">
              {t('installation.android.qr.s4')}
            </h3>
            <img
              src={Five}
              alt="Android Download your SIM - Next"
              className="max-w-xs mx-auto border border-gray-200 rounded-lg shadow-sm"
            />
          </div>

          <div>
            <h3 className="text-lg font-medium text-gray-900 mb-4">
              {t('installation.android.qr.s5')}
            </h3>
            <img
              src={Six}
              alt="Android Scan QR code"
              className="max-w-xs mx-auto border border-gray-200 rounded-lg shadow-sm"
            />
          </div>

          <div>
            <h3 className="text-lg font-medium text-gray-900 mb-4">
              {t('installation.android.qr.s6')}
            </h3>
          </div>

          <div>
            <h3 className="text-lg font-medium text-gray-900 mb-4">
              {t('installation.android.qr.s7')}
            </h3>
          </div>

          <div>
            <h3 className="text-lg font-medium text-gray-900 mb-4">
              {t('installation.android.qr.s8')}
            </h3>
            <img
              src={Seven}
              alt="Android Downloading Data eSIM"
              className="max-w-xs mx-auto border border-gray-200 rounded-lg shadow-sm"
            />
          </div>

          <div>
            <h3 className="text-lg font-medium text-gray-900 mb-4">
              {t('installation.android.qr.s9')}
            </h3>
            <img
              src={Eight}
              alt="Android Download Finished"
              className="max-w-xs mx-auto border border-gray-200 rounded-lg shadow-sm"
            />
          </div>

          <div>
            <h3 className="text-lg font-medium text-gray-900 mb-4">
              {t('installation.android.qr.s10')}
            </h3>
            <img
              src={Nine}
              alt="Android Data eSIM Setup"
              className="max-w-lg mx-auto border border-gray-200 rounded-lg shadow-sm"
            />
          </div>
        </div>
      </section>

      {/* Important Notes */}
      <section className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-8">
        <h3 className="text-lg font-semibold text-blue-900 mb-3">
          {t('installation.notes.title')}
        </h3>
        <ul className="space-y-2 text-blue-800">
          <li>• {t('installation.notes.n1')}</li>
          <li>• {t('installation.notes.n2')}</li>
          <li>• {t('installation.notes.n3')}</li>
          <li>• {t('installation.notes.n4')}</li>
          <li>• {t('installation.notes.n5')}</li>
        </ul>
      </section>

      {/* Support Section */}
      <section className="text-center bg-gray-50 rounded-lg p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-2">
          {t('installation.support.title')}
        </h3>
        <p className="text-gray-600 mb-4">
          {t('installation.support.body')}
        </p>
        <div className="space-y-1 text-sm text-gray-600">
          <p><strong>{t('installation.support.emailLabel')}</strong> support@routedlabs.com</p>
          <p><strong>{t('installation.support.websiteLabel')}</strong> airvoy.app/support</p>
        </div>
      </section>
    </div>
  );
};

export default AndroidGuide;